<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view  v-if="isRouterAlive" ></router-view>
    </transition>
  </div>
</template>

<script>
//export default {
  //name: "app",
  //created() {
    // // 在页面加载时读取sessionStorage
    // if (sessionStorage.getItem("store")) {
    //   this.$store.replaceState(
    //     Object.assign(
    //       {},
    //       this.$store.state,
    //       JSON.parse(sessionStorage.getItem("store"))
    //     )
    //   );
    // }
    // // 在页面刷新时将store保存到sessionStorage里
    // window.addEventListener("beforeunload", () => {
    //   sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    // });
 // }
//};



export default {

  name: 'app',

  provide (){

    return {

      reload:this.reload

    }

  },

  data(){

    return {

      isRouterAlive:true

    }

  },

  methods:{

    reload (){

      this.isRouterAlive = false

      this.$nextTick(function(){

          this.isRouterAlive = true

      })

    }

  }

}


</script>

<style lang="scss">
body {
  margin: 0px;
  padding: 0px;
  font-family: Microsoft YaHei, Helvetica Neue, Helvetica, PingFang SC,
    Hiragino Sans GB, SimSun, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

#app {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
}
a {
  color: #56a9ff;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/system/index/App.vue